import type { ReactNode } from "react";

import { Icon_FillerSvg24 } from "./FillerSvg";

import style from "./DoubleIconLabel.module.css";

export const DoubleIconLabel: React.FC<{ icon1: ReactNode; icon2: ReactNode; label: string }> = ({
  icon1,
  icon2,
  label,
}) => {
  return (
    <div className={style.doubleIconLabel}>
      {icon1 ? icon1 : <Icon_FillerSvg24 />}
      {icon2 ? icon2 : <Icon_FillerSvg24 />}
      <span>{label}</span>
    </div>
  );
};
